export default __webpack_public_path__ + "static/media/K_Forms.9dec8cf1.png";